import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { Loader2, ShieldCheck, AlertCircle } from 'lucide-react';

export default function AdminSignUpSecret() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAdminSignUp = async (e) => {
    e.preventDefault();
    setError('');

    // Simple verification to prevent accidental public use
    if (secretKey !== 'lobab2026') {
      setError('مفتاح الأمان غير صحيح');
      return;
    }

    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Create an admin document in Firestore
      await setDoc(doc(db, 'users', user.uid), {
        name,
        email,
        role: 'admin',
        registrationDate: serverTimestamp(),
      });

      navigate('/admin/overview');
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/email-already-in-use') {
        setError('البريد الإلكتروني مستخدم بالفعل');
      } else {
        setError('حدث خطأ أثناء إنشاء حساب الإدارة');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-zinc-950 px-4" dir="rtl">
      <div className="max-w-md w-full bg-white dark:bg-zinc-900 rounded-3xl shadow-xl border border-slate-100 dark:border-zinc-800 p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary-50 dark:bg-primary-900/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <ShieldCheck className="w-8 h-8 text-primary-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white">إنشاء حساب أدمن جديد</h2>
          <p className="text-slate-500 dark:text-slate-400 mt-2">خاص لمدراء لُباب فقط</p>
        </div>

        {error && (
          <div className="mb-6 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 p-4 rounded-xl flex items-start gap-3">
            <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <p className="text-mdfont-medium">{error}</p>
          </div>
        )}

        <form onSubmit={handleAdminSignUp} className="space-y-5">
          <div>
            <label className="block text-mdfont-medium text-slate-700 dark:text-slate-300 mb-1.5">مفتاح الأمان</label>
            <input
              type="password"
              required
              value={secretKey}
              onChange={(e) => setSecretKey(e.target.value)}
              className="block w-full px-4 py-3 border border-slate-200 dark:border-zinc-700 rounded-xl bg-slate-50 dark:bg-zinc-800 text-slate-900 dark:text-white"
              placeholder="أدخل رمز الأمان للإنشاء"
            />
          </div>
          <div>
            <label className="block text-mdfont-medium text-slate-700 dark:text-slate-300 mb-1.5">الاسم</label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="block w-full px-4 py-3 border border-slate-200 dark:border-zinc-700 rounded-xl bg-slate-50 dark:bg-zinc-800 text-slate-900 dark:text-white"
            />
          </div>
          <div>
            <label className="block text-mdfont-medium text-slate-700 dark:text-slate-300 mb-1.5">البريد الإلكتروني</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="block w-full px-4 py-3 border border-slate-200 dark:border-zinc-700 rounded-xl bg-slate-50 dark:bg-zinc-800 text-slate-900 dark:text-white"
            />
          </div>
          <div>
            <label className="block text-mdfont-medium text-slate-700 dark:text-slate-300 mb-1.5">كلمة المرور</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full px-4 py-3 border border-slate-200 dark:border-zinc-700 rounded-xl bg-slate-50 dark:bg-zinc-800 text-slate-900 dark:text-white"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-base font-medium text-white bg-primary-600 hover:bg-primary-700 transition-all font-bold"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'إنشاء حساب مدير'}
          </button>
        </form>
      </div>
    </div>
  );
}
